import React from 'react';
import { useTranslation } from 'react-i18next';

import InfoSmallIcon from '@/assets/icons/info-small';
import StrikedThroughDotLarge from '@/assets/icons/striked-through-dot-large';
import { Text } from '@/components/TextComponent';
import { Box, TouchableBox } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { BetSelection } from '@/feature/bets-sbk/hooks/types';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';
import { designSystem } from '@/styles/styles';

export const BetSelectionVoidedInfo = ({ selection }: { selection: BetSelection }) => {
    const { t } = useTranslation(['bets']);
    const { showInfoSheet } = useAlerts();

    const isPredictions = useIsPredictionsProduct();
    const isSelectionCashedOut = selection.result === 'CASHEDOUT';
    const cashedOutDescription = isPredictions ? t('position_sold_desc') : t('cashed_out_desc');

    const handleVoidAlertPress = () =>
        showInfoSheet({
            title: t('voided_leg_title'),
            description: isSelectionCashedOut ? cashedOutDescription : t('voided_leg_desc'),
            buttonLabel: t('got_it'),
            icon: (
                <Box
                    width={72}
                    height={72}
                    backgroundColor={ds.colorToken.background.neutral.subtle}
                    borderRadius="r96"
                    justifyContent="center"
                    alignItems="center"
                >
                    <StrikedThroughDotLarge width={'36'} height={'36'} fillColor={ds.colorValue.icon.primary} />
                </Box>
            ),
        });

    return (
        <Box flexDirection="row" alignItems="center" gap="s4" paddingVertical="s2">
            <Text variant="titleSmall" color="neutral300">
                {isSelectionCashedOut ? t(isPredictions ? 'voided_sold_leg' : 'voided_cashout_leg') : t('voided_leg')}
            </Text>
            <TouchableBox onPress={handleVoidAlertPress}>
                <InfoSmallIcon
                    size={16}
                    color={designSystem.colors.neutral300}
                    fillColor={designSystem.colors.neutral300}
                />
            </TouchableBox>
        </Box>
    );
};
